const SET_THEME = (state, payload) => {
  state.theme = payload;
};

export default SET_THEME;
